module.exports = __webpack_public_path__ + "static/media/img_0343.9cb306ee.jpg";